import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class PageTitleService {
    constructor(private title: Title) {}

    setTitle(title?: string, context?: string): void {
        const pageLabel = [context, title].filter(Boolean).join(' - ');
        const fullTitle = [pageLabel, environment.titleAppend].filter(Boolean).join(' | ');
        this.title.setTitle(fullTitle);
    }
}
